export const ADD_COMMENT = 'ADD_COMMENT';
export const DIISHES_LOADING = 'DISHES_LOADING';
export const DISHES_FAILED = 'DISHES_FAILED';
export const ADD_DISHES = 
'ADD_DISHES';

